import React from 'react'

import CandidateIntroSection from './CandidateIntroSection'
import SummaryList from './SummaryList'
import PhotoCarousel from './PhotoCarousel'
import VideoCarousel from './VideoCarousel'
import FundraisingSummary from './FundraisingSummary'
import EndorsementBlock from './EndorsementBlock'
import LinksBlock from 'pages/june-5/props/components/LinksBlock'
import BottomNav from 'pages/june-5/props/components/BottomNavBlock';
import SocialMediaButtons from 'components/interactive/socialMedia/SocialMediaButtons'

import {Spacer} from 'layout/util'
import Head from 'layout/head'

const CandidatePage = (props) => {
	const {pageId, meta, intro, sections} = props.data;

	const bodySections = sections.map( (section,i) => {
		const {type, data, id} = section;
		switch(type) {
			case "summary-list":
				return (<SummaryList listNItems={2} key={i} data={data} sectionId={id}/>);
			case "photo-carousel":
				return (<PhotoCarousel key={i} data={data} sectionId={id}/>);
			case "video-carousel":
				return (<VideoCarousel key={i} data={data} sectionId={id}/>);
			case "fundraising-summary":
				return (<FundraisingSummary key={i} data={data} sectionId={id}/>);
			case "links-block":
				return (<LinksBlock key={i} data={data} sectionId={id}/>);
			case "endorsements-list":
				return (<EndorsementBlock key={i} data={data} sectionId={id}/>);
			case "bottom-nav":
				return (<BottomNav bottomOut color={intro.color} key={i} data={data} sectionId={id}/>);
			default:
				return null;
		}	
	});

	const {canonicalUrl, documentTitle, socialHeadline, socialDescription, socialImage} = meta;
	return(
		<div pageid={pageId}>
	    <Head
	      url={canonicalUrl}
	      title={documentTitle}
	      headline={socialHeadline}
	      description={socialDescription}
	      image={socialImage}
	    />

			<CandidateIntroSection
				data={intro}
			/>
		 	{bodySections}	
		 	<SocialMediaButtons/>
		 	<Spacer height={70}/>
		</div>
	)
}

export default CandidatePage;


// WEBPACK FOOTER //
// ./src/pages/june-5/races/components/CandidatePage.js